import MainNav from './ui/MainNav';
import MobileNav from './ui/MobileNav';
import { useLocation } from 'react-router-dom';

const Navbar = () => {
    const location = useLocation();
    const isAdminRoute = location.pathname.includes('/admin-dashboard') ||
        location.pathname.includes('/login-admin') ||
        location.pathname.includes('/create-admin');

    // Don't render navbar on admin routes
    if (isAdminRoute) return null;

    return (
        <div>
            <div className="hidden lg:block">
                <MainNav />
            </div>
            <div className="block lg:hidden">
                <MobileNav />
            </div>
        </div>
    );
}

export default Navbar;
